import React from 'react';
import '../../styles/MarkerDetailsModal.css';
import { getExtendedMarkerInfo } from '../../data/markerDescriptions.extended';
import BottomSheet from '../BottomSheet/BottomSheet';

function MarkerDetailsModal({ markerName, markerInfo, onClose }) {
    const extended = getExtendedMarkerInfo(markerName);

    return (
        <BottomSheet onClose={onClose} className="marker-modal">
            {({ onClose: handleClose }) => (
                <>
                    <div className="modal-header">
                        <h2>{markerName}</h2>
                        <button className="close-btn" onClick={handleClose} aria-label="Close modal">×</button>
                    </div>
                    <div className="modal-body">
                        <section>
                            <h3>What it measures</h3>
                            <p>{markerInfo.description}</p>
                        </section>

                        {(markerInfo.high || extended?.whenHigh) && (
                            <section>
                                <h3>When elevated</h3>
                                <p>{extended?.whenHigh?.detail || markerInfo.high}</p>
                                {extended?.whenHigh?.supplements && (
                                    <div className="marker-recommendations">
                                        <h4>Supplements to consider</h4>
                                        {extended.whenHigh.supplements.map((group, idx) => (
                                            <div key={idx} className="supplement-group">
                                                <span className="supplement-category">{group.category}:</span>
                                                <span className="supplement-items">{group.items.join(', ')}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {extended?.whenHigh?.lifestyle && (
                                    <div className="marker-recommendations">
                                        <h4>Lifestyle changes</h4>
                                        <ul className="lifestyle-list">
                                            {extended.whenHigh.lifestyle.map((tip, idx) => (
                                                <li key={idx}>{tip}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </section>
                        )}

                        {(markerInfo.low || extended?.whenLow) && (
                            <section>
                                <h3>When low</h3>
                                <p>{extended?.whenLow?.detail || markerInfo.low}</p>
                                {extended?.whenLow?.supplements && (
                                    <div className="marker-recommendations">
                                        <h4>Supplements to consider</h4>
                                        {extended.whenLow.supplements.map((group, idx) => (
                                            <div key={idx} className="supplement-group">
                                                <span className="supplement-category">{group.category}:</span>
                                                <span className="supplement-items">{group.items.join(', ')}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {extended?.whenLow?.lifestyle && (
                                    <div className="marker-recommendations">
                                        <h4>Lifestyle changes</h4>
                                        <ul className="lifestyle-list">
                                            {extended.whenLow.lifestyle.map((tip, idx) => (
                                                <li key={idx}>{tip}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </section>
                        )}

                        {extended?.relatedMarkers && (
                            <section>
                                <h3>Related markers</h3>
                                <ul>
                                    {extended.relatedMarkers.map(m => (
                                        <li key={m.name}>
                                            <strong>{m.name}</strong>: {m.relationship}
                                        </li>
                                    ))}
                                </ul>
                            </section>
                        )}

                        {extended?.clinicalNote && (
                            <section>
                                <h3>Clinical context</h3>
                                <p>{extended.clinicalNote}</p>
                            </section>
                        )}

                        {extended?.sources && (
                            <section className="sources-section">
                                <h3>More Reading</h3>
                                <ul className="sources-list">
                                    {extended.sources.map((source, idx) => (
                                        <li key={idx}>
                                            <a href={source.url} target="_blank" rel="noopener noreferrer">
                                                {source.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </section>
                        )}
                    </div>
                </>
            )}
        </BottomSheet>
    );
}

export default MarkerDetailsModal;
